import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { DataTransferTypes } from '../../media/mimeConstants';

/**
 * Keeps copied table cells readable in every text editor.
 */
export const TablePaste = Extension.create({
    name: 'tablePaste',

    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('tablePaste'),
                props: {
                    handlePaste: (view, event) => {
                        if (!event.clipboardData) return false;

                        const html = event.clipboardData.getData(DataTransferTypes.HTML);
                        const text = event.clipboardData.getData(DataTransferTypes.PLAIN_TEXT);
                        if (!text || !/<table\b/i.test(html)) return false;

                        const body = new DOMParser().parseFromString(html, 'text/html').body;
                        if (!body.querySelector('table')) return false;

                        // Ignore spreadsheet wrappers and metadata, but preserve rich content outside the tables.
                        body.querySelectorAll('table, style, script').forEach((node) => node.remove());
                        const hasOtherContent =
                            body.textContent?.trim() ||
                            body.querySelector('img, svg, video, audio, iframe, object, embed, hr, canvas');
                        if (hasOtherContent) return false;

                        const plainTextPasteEvent = new Event('paste') as ClipboardEvent;
                        return view.pasteText(text, plainTextPasteEvent);
                    },
                },
            }),
        ];
    },
});
